import * as React from "react";
import { Component } from "react";
import Loader from "react-loader-spinner";
import "../../css/components/common/spinner.css";
import { ILoadingStatusProps } from "./interfaces";

export default class LoadingStatus extends Component<ILoadingStatusProps> {
  public constructor(props: ILoadingStatusProps) {
    super(props);
  }

  public render() {
    const width = this.props.width ? this.props.width : 100;
    const height = this.props.height ? this.props.height : 100;
    const className = this.props.singular
      ? "spinner-container-singular"
      : "container spinner-container container-fixed-navbar";
    return (
      <div className={className}>
        <Loader
          width={width}
          height={height}
          type={this.props.type ? this.props.type : "Watch"}
          color="blue"
        />
        {this.props.text ? <h3 className="spinner-header">{this.props.text}</h3> : ""}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/LoadingStatus.tsx